import React from 'react';
import { IMaskInput } from 'react-imask';

// Định nghĩa các mask patterns
const MASK_PATTERNS = {
  phone: {
    mask: '(000) 000-0000',
    placeholder: '(123) 456-7890',
  },
  ssn: {
    mask: '000-00-0000',
    placeholder: '123-45-6789',
  },
  number: {
    mask: Number,
    scale: 0,
    thousandsSeparator: ',',
    placeholder: '1,234,567',
  },
  decimal: {
    mask: Number,
    scale: 2,
    radix: '.',
    thousandsSeparator: ',',
    placeholder: '1,234.56',
  },
  zipcode: {
    mask: '00000',
    placeholder: '12345',
  },
  date: {
    mask: '00/00/0000',
    placeholder: 'MM/DD/YYYY',
  },
  creditCard: {
    mask: '0000 0000 0000 0000',
    placeholder: '1234 5678 9012 3456',
  },
  currency: {
    mask: '$num',
    blocks: {
      num: {
        mask: Number,
        scale: 2,
        thousandsSeparator: ',',
        radix: '.',
      },
    },
    placeholder: '$1,234.56',
  },
} as const;

type MaskType = keyof typeof MASK_PATTERNS;

interface MaskedInputProps {
  maskType?: MaskType;
  /** Số chữ số thập phân (chỉ áp dụng khi mask là Number, ví dụ decimal/number/currency) */
  scale?: number;
  /** Cho phép nhập/hiển thị số âm (decimal, number, currency) */
  allowNegative?: boolean;
  value?: string | number;
  onChange?: (value: string) => void;
  style?: React.CSSProperties;
  [key: string]: any;
}

const MaskedInput: React.FC<MaskedInputProps> = ({ 
  maskType = 'number', 
  scale,
  allowNegative = false,
  value, 
  onChange, 
  style,
  ...props 
}) => {
  const base = MASK_PATTERNS[maskType];
  const isNumberMask =
    base &&
    typeof base === 'object' &&
    (base as { mask?: unknown }).mask === Number;
  const maskConfig = isNumberMask
    ? {
        ...base,
        ...(typeof scale === 'number' ? { scale } : {}),
        ...(allowNegative ? { signed: true } : {}),
      }
    : base;

  return (
    <IMaskInput
      {...(maskConfig as any)}
      {...props}
      value={value?.toString() || ''}
      unmask={false} // true nếu muốn giá trị không có ký tự mask
      onAccept={(value: string) => {
        onChange?.(value);
      }}
      style={{
        width: '100%',
        padding: '4px 11px',
        fontSize: '14px',
        lineHeight: '1.5715',
        border: '1px solid #d9d9d9',
        borderRadius: '2px',
        ...style,
      }}
      // className="ant-input"
    />
  );
};

export default MaskedInput;